var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2706_367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.662 233.836L277.204 16.3939C264.69 3.86871 244.377 3.86871 231.847 16.3939L186.692 61.549L243.973 118.83C257.285 114.333 272.548 117.349 283.16 127.962C293.822 138.64 296.817 154.034 292.21 167.39L347.415 222.595C360.771 217.993 376.181 220.972 386.848 231.655C401.756 246.558 401.756 270.712 386.848 285.625C371.935 300.538 347.781 300.538 332.862 285.625C321.649 274.4 318.878 257.93 324.556 244.115L273.073 192.632L273.067 328.113C276.701 329.917 280.133 332.316 283.16 335.332C298.068 350.234 298.068 374.389 283.16 389.313C268.247 404.221 244.082 404.221 229.191 389.313C214.283 374.389 214.283 350.234 229.191 335.332C232.874 331.654 237.136 328.873 241.683 327.004V190.26C237.136 188.402 232.879 185.637 229.191 181.932C217.895 170.652 215.179 154.078 220.966 140.208L164.505 83.7358L15.3994 232.83C2.86881 245.366 2.86881 265.679 15.3994 278.204L232.858 495.651C245.377 508.176 265.684 508.176 278.22 495.651L494.662 279.215C507.187 266.684 507.187 246.361 494.662 233.836",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 498.054,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/Git.64002133d67a5c4040c87317d30fba86.svg";
export { ForwardRef as ReactComponent };